import { Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import ProjectDetails from "./pages/ProjectDetails";
import Store from "./pages/store/index";
import ProjectPreview from "./pages/ProjectPreview";
import About from "./pages/About";
import Contact from "./pages/Contact";
import { Toaster } from "react-hot-toast";
import { SpeedInsights } from "@vercel/speed-insights/react";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    <>
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            color: "#fff",
            marginTop: "-3px",
            borderRadius: "var(--border-radius)",
            padding: "var(--space-smaller) var(--space-small)",
            fontSize: "16px",
            fontFamily: "Montserrat",
          },
          success: {
            style: {
              background: "var(--success-color)",
            },
            iconTheme: {
              primary: "var(--background-color)",
              secondary: "#fff",
            },
          },
          error: {
            style: {
              background: "var(--danger-color)",
            },
            iconTheme: {
              primary: "var(--background-color)",
              secondary: "#fff",
            },
          },
        }}
      />
      <SpeedInsights />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />}></Route>
        <Route path="/store" element={<Store />}></Route>
        <Route path="/project/:type/:id" element={<ProjectDetails />}></Route>
        <Route path="/preview/:type/:id" element={<ProjectPreview />}></Route>
        <Route path="/about" element={<About />}></Route>
        <Route path="/contact" element={<Contact />}></Route>
      </Routes>
    </>
  );
}

export default App;
